export const ORG_APPROVAL_SAMPLE = {
  firstName: 'John',
  lastName: 'Doe',
  email: 'johndoe@highair.com',
};
